<template>
  <div>
    <main-layout class="pa-3 rsu">
      <v-container>
        <div class="headline primary--text">JOBD2U</div>
        <div class="text-xs-right rsu">
          <v-btn @click="exportTemplate" outline color="grey">Export template</v-btn>
          <ImportJob @createData="createData"></ImportJob>
        </div>
        <v-layout row wrap>
          <v-flex xs7>
            <div>
              <v-btn
                @click="changeCategory('all')"
                color="primary"
                :depressed="checkActive('all')"
                :outline="!checkActive('all')"
                >All</v-btn
              >
              <v-btn
                @click="changeCategory('it')"
                color="primary"
                :depressed="checkActive('it')"
                :outline="!checkActive('it')"
                >IT</v-btn
              >
              <v-btn
                @click="changeCategory('non-it')"
                color="primary"
                :depressed="checkActive('non-it')"
                :outline="!checkActive('non-it')"
                >Non-IT</v-btn
              >
            </div>
          </v-flex>
          <v-flex xs5>
            <div class="text-xs-right rsu">
              <v-btn @click="addJob" depressed color="primary" class="rsu">
                <v-icon>mdi-plus</v-icon> <span class="rsu">เพิ่มประกาศงาน</span>
              </v-btn>
            </div></v-flex
          >
        </v-layout>

        <v-data-table
          expand
          hide-actions
          :loading="loading"
          :headers="headers"
          :items="data"
          class="elevation-1 "
        >
          <template v-slot:items="props">
            <tr style="cursor: pointer">
              <td class="text-xs-center">
                <v-img
                  lazy-src="@/assets/whiteimg.jpg"
                  width="100%"
                  :src="getImage(props.item.Logo)"
                >
                  <template v-slot:placeholder>
                    <div class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular
                        indeterminate
                        size="15"
                        color="grey"
                      ></v-progress-circular>
                    </div>
                  </template>
                </v-img>
              </td>
              <td class="text-xs-left">{{ props.item.Name }}</td>
              <td class="text-xs-left">{{ props.item.Position ? props.item.Position : '-' }}</td>
              <td class="text-xs-left">{{ props.item.Type ? props.item.Type : '-' }}</td>
              <td class="text-xs-left">
                <v-btn @click="showEditData(props.item)" icon outline color="primary">
                  <v-icon>edit</v-icon></v-btn
                >
                <v-btn @click="checkDelete(props.item._id)" icon outline color="primary">
                  <v-icon>delete</v-icon></v-btn
                >
              </td>
              <!-- <td class="text-xs-left">
              </td> -->
            </tr>
          </template>
        </v-data-table>
      </v-container>
    </main-layout>
    <v-dialog v-model="showEdit" width="600px" persistent>
      <v-card>
        <EditData
          @createData="createData"
          @updateData="createData"
          v-if="showEdit"
          @close="closeEdit"
          :editType="currentEditType"
          :editData="currentEditData"
        ></EditData>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import axios from 'axios'
import api from '@/api'
import XLSX from 'xlsx'
import EditData from './EditData.vue'
import ImportJob from './ImportJob.vue'
export default {
  components: { EditData, ImportJob },
  data() {
    return {
      loading: false,
      active: 'all',
      showEdit: false,
      currentEditType: '',
      currentEditData: '',
      apikey: 'Zi0jETDUGp4JtEGSx3HEbe75w7ygyIAL',
      headers: [
        { text: '', value: '', width: '1%' },
        { text: 'ชื่อบริษัท', value: 'Name', align: 'center', width: '2%' },
        { text: 'ตำแหน่ง', value: 'Position', align: 'center', width: '2%' },
        { text: 'ประเภท', value: 'Type', align: 'center', width: '2%' },
        { text: '', value: '', sortable: false, width: '1%' }
      ],
      data: []
    }
  },
  mounted() {
    this.getJobs()
  },
  methods: {
    showEditData(item) {
      this.currentEditData = item
      this.currentEditType = 'edit'
      this.showEdit = true
    },
    async checkDelete(id) {
      var result = await this.$swal.fire({
        title: this.$t('ต้องการจะลบประกาศงานใช่หรือไม่', {
          name: ''
        }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        console.log('Delete : ', id)
        let code = await api.deletejobD2u(id)
        if (code == 200) {
          this.$swal.fire({
            title: this.$t('Successfully'),
            type: 'success'
          })
          this.getJobs()
        } else {
          this.$swal.fire({
            title: this.$t('Unsuccessful'),
            type: 'error'
          })
        }
      }
    },
    async createData() {
      await this.$swal.fire({
        type: 'success',
        text: 'สำเร็จ'
      })
      this.showEdit = false
      this.getJobs()
    },
    closeEdit() {
      this.showEdit = false
    },
    getImage(Logo) {
      if (Logo && Logo.length > 1 && Logo.includes('drive.google')) {
        return 'https://drive.google.com/uc?export=view&id=' + this.getIdFromUrl(Logo)
      } else return Logo
    },
    changeCategory(category) {
      this.active = category
      this.getJobs()
    },
    checkActive(item) {
      return item == this.active
    },
    addJob() {
      this.currentEditType = 'create'
      this.showEdit = true
    },
    getJobs() {
      var url = ''
      if (this.active == 'all') {
        url = 'depajobd2ualljobsdashboard'
      } else if (this.active == 'it') {
        url = 'depajobd2ucategoryitdashboard'
      } else {
        url = 'depajobd2ucategorynonitdashboard'
      }
      this.loading = true
      api[url]({}, (err, response) => {
        this.loading = false
        this.data = response.data
      })
    },
    getIdFromUrl(url) {
      if (url) {
        return url.match(/[-\w]{25,}/)
      } else {
        return ''
      }
    },
    exportTemplate() {
      let vm = this
      let header = 'data:text/csv;charset=utf-8,%EF%BB%BF'
      let csvContent = ''
      let orders = []
      let filename = 'jobd2u-import-template'

      var json = []

      json = [
        {
          'ลิงค์รูป Logo':
            'https://s3.amazonaws.com/zwizai/ecommerce%2F1629339586089966e4b5f-eeda-4516-9f02-28aa805c2c18.jpg',
          ชื่อบริษัท: 'Robolingo',
          โปรไฟล์: 'บริการแชทบอทสำเร็จรูป & รับทำตาม requirement',
          ที่อยู่: '211 ถนนรามอินทรา แขวง/เขต มีนบุรี กทม. 10510',
          Lat: '13.8329',
          Long: '100.7296',
          เว็บไซต์: 'https://www.google.com',
          จังหวัด: 'กรุงเทพมหานคร',
          รูปแบบการจ้าง: 'พนักงานประจำ',
          หมวดหมู่งาน: 'Database Management',
          จำนวนที่รับ: '2',
          คุณสมบัติ: 'ประสบการณ์อย่างน้อย 2 ปี',
          ความต้องการ: 'ไม่มี',
          ทักษะ: 'Microsoft Office',
          เงินเดือน: '40,000',
          ผลประโยชน์: 'สวัสดิการพนักงาน',
          ตำแหน่ง: 'Business analyst',
          รายละเอียดงาน: 'เวลาทำงาน 09.00 - 18.00 น.',
          อีเมลสำหรับยื่นใบสมัคร: 'email@exam.com',
          เว็บไซต์สำหรับยื่นใบสมัคร: 'https://www.google.com'
        }
      ]

      var dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, filename + '.xlsx')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/jobd2u/main.vue